/**
 * Firebase app + Auth singleton.
 *
 * Config comes from Vite env vars — copy frontend/.env.example to
 * frontend/.env.local and fill in the values from the Firebase console
 * (Project settings → General → "Your apps" → Config).
 *
 * Firebase's "API key" isn't a secret — it identifies the project, not
 * authenticates it. Security is enforced server-side by Firebase rules
 * and (optionally) your backend verifying ID tokens. We still env-ize
 * the values so dev/prod can point at different projects.
 */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId:             import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey) {
  // Don't throw — render a helpful error inside the Auth screen instead.
  // eslint-disable-next-line no-console
  console.warn(
    '[firebase] VITE_FIREBASE_API_KEY is not set. ' +
    'Copy frontend/.env.example to frontend/.env.local and fill in the config.',
  );
}

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
